"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidInputType = isValidInputType;
function isValidInputType(cardNumber) {
    return typeof cardNumber === "string" || cardNumber instanceof String;
}
